module.exports = __webpack_public_path__ + "static/media/Baxter_Sales.2adbae0c.pdf";